import type {GetTokens, WorkHit} from './types';
import agentWorksQuery from './data/agentWorksQuery.json';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpElasticV2} from './http/search/httpElastic';
import {mapWorkHits} from './mappers/mapWorkHits';
import type {SearchSchemas} from './search.dto.generated';
import type {SearchResult, SearchResultDto} from './searchTypes';

export const searchAgentWorks = (
  agentId: string,
  page: number,
  size: number,
  getTokens: GetTokens,
  signal?: AbortSignal,
): Promise<SearchResult<WorkHit>> => {
  /**
   * Placed the JSON in a file to easier debug it in elastic cloud console.
   */
  const query = JSON.stringify(agentWorksQuery).replaceAll(
    '${QUERY_PLACEHOLDER}',
    agentId,
  );

  // Sort works by newest manifestation
  const sort = [
    {
      'expressions.manifestations.publishedYear': {
        missing: '_last',
        order: 'desc',
        mode: 'max',
        nested: {
          path: 'expressions.manifestations',
        },
        unmapped_type: 'string',
      },
    },
  ];

  return exceptionToPromiseReject(() =>
    httpElasticV2<SearchResultDto<SearchSchemas.WorkDocument>>(
      getTokens,
      'ebs-work-alias',
      JSON.parse(query),
      page,
      size,
      undefined,
      signal,
      false,
      sort,
    ).then(mapWorkHits),
  );
};
